import { $ as jquery } from 'jquery';
import { tree } from './tree.js';
import { layer } from './layer.js';
import { getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml } from './mediaManageResponsive.js';

var $ = jquery;

var escapeHtml = function (value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

var trimText = function (value) {
  return value == null ? '' : String(value).trim();
};

var normalizeId = function (value) {
  if (value == null || value === '' || value === false) {
    return '0';
  }
  return String(value);
};

var stripTreePrefix = function (title) {
  return trimText(title).replace(/^[\s\u00a0\u3000]*└-*/, '');
};

var flattenTree = function (nodes, level, result) {
  (nodes || []).forEach(function (item) {
    result.push({
      id: item.id,
      title: item.rawTitle,
      level: level,
      pid: item.pid,
    });
    flattenTree(item.children, level + 1, result);
  });
};

var buildTreeData = function (list) {
  var nodes = [];
  var map = {};
  var roots = [];
  var flat = [];

  (list || []).forEach(function (item) {
    var node = $.extend({}, item);
    node.id = normalizeId(node.id);
    node.pid = normalizeId(node.pid);
    node.rawTitle = stripTreePrefix(node.rawTitle || node.title || '');
    node.title = node.rawTitle;
    node.children = [];
    node.spread = true;
    nodes.push(node);
    map[node.id] = node;
  });

  nodes.forEach(function (node) {
    if (node.pid !== '0' && map[node.pid] && node.pid !== node.id) {
      map[node.pid].children.push(node);
    } else {
      roots.push(node);
    }
  });

  flattenTree(roots, 0, flat);

  return {
    treeData: roots,
    flatData: flat,
    map: map,
  };
};

var createNameDialog = function (options) {
  var dialogOptions = getMediaDialogFormOptions();
  layer.open({
    type: 1,
    title: options.title,
    closeBtn: 1,
    shadeClose: false,
    skin: dialogOptions.skin,
    resize: false,
    scrollbar: false,
    area: dialogOptions.area,
    content: createMediaFormFieldHtml({
      label: escapeHtml(options.label),
      fieldHtml:
        "<input type='text' class='layui-input' value='" +
        escapeHtml(options.value || '') +
        "'>"
    }),
    btn: [options.confirmText, options.cancelText],
    yes: function (index, layero) {
      var value = trimText($(layero).find('input').val());
      if (value === '') {
        layer.msg(options.requiredText);
        return;
      }
      options.onConfirm(value, index);
    },
  });
};

var createMediaCategoryTree = function (options) {
  var $container = $(options.elem);
  var state = {
    treeData: [],
    flatData: [],
    map: {},
  };

  var renderShell = function () {
    $container.html(
      '<div class="media-category-root" data-id="0"><span class="media-category-root-text">' +
        escapeHtml(options.allLabel) +
        '</span></div>' +
        '<div class="media-category-tree"></div>',
    );
  };

  var getTreeWrap = function () {
    return $container.find('.media-category-tree');
  };

  var applySelection = function () {
    var currentId = normalizeId(options.getSelectedId());

    if (currentId !== '0' && !state.map[currentId]) {
      currentId = '0';
      options.setSelectedId(0);
    }

    $container
      .find('.media-category-root')
      .toggleClass('is-active', currentId === '0');
    $container.find('.layui-tree-txt').removeClass('media-category-selected');

    if (currentId !== '0') {
      $container
        .find('.layui-tree-set[data-id="' + currentId + '"] > .layui-tree-entry .layui-tree-txt')
        .addClass('media-category-selected');
    }
  };

  var selectCategory = function (id, triggerSearch) {
    var nextId = normalizeId(id);
    options.setSelectedId(nextId === '0' ? 0 : nextId);
    applySelection();
    if (triggerSearch && typeof options.onSelect === 'function') {
      options.onSelect(nextId === '0' ? 0 : nextId);
    }
  };

  var renderActions = function () {
    getTreeWrap()
      .find('.layui-tree-set')
      .each(function () {
        var $set = $(this);
        var id = normalizeId($set.data('id'));
        var item = state.map[id];
        var $main = $set.find('> .layui-tree-entry > .layui-tree-main');

        if (!item || !$main.length || $main.children('.media-category-actions').length) {
          return;
        }

        $main.append(
          '<span class="media-category-actions">' +
            '<i class="layui-icon layui-icon-add-1 media-category-action" data-action="add" title="' +
            escapeHtml(options.texts.addGroup) +
            '"></i>' +
            '<i class="layui-icon layui-icon-edit media-category-action" data-action="edit" title="' +
            escapeHtml(options.texts.edit) +
            '"></i>' +
            '<i class="layui-icon layui-icon-delete media-category-action" data-action="delete" title="' +
            escapeHtml(options.texts.delete) +
            '"></i>' +
            '</span>',
        );
      });
  };

  var reload = function () {
    renderShell();
    $.ajax({
      type: 'get',
      dataType: 'json',
      url: options.categoryUrl,
      success: function (result) {
        if (result.code != 0) {
          layer.msg(result.msg);
          return;
        }

        var treeResult = buildTreeData(result.data || []);
        state.treeData = treeResult.treeData;
        state.flatData = treeResult.flatData;
        state.map = treeResult.map;

        tree.render({
          elem: getTreeWrap(),
          data: state.treeData,
          showLine: true,
          onlyIconControl: true,
          click: function (obj) {
            selectCategory(obj.data.id, true);
          },
        });

        renderActions();
        applySelection();
      },
    });
  };

  var openAddDialog = function (pid) {
    createNameDialog({
      title: options.texts.newGroup,
      label: options.texts.groupName,
      value: '',
      confirmText: options.texts.confirm,
      cancelText: options.texts.cancel,
      requiredText: options.texts.groupNameRequired,
      onConfirm: function (value, index) {
        $.ajax({
          type: 'post',
          dataType: 'json',
          url: options.updateUrl,
          data: { title: value, pid: pid || 0 },
          success: function (result) {
            if (result.code == 0) {
              layer.close(index);
              if (result.data && result.data.id) {
                options.setSelectedId(result.data.id);
              }
              reload();
            } else {
              layer.msg(result.msg);
            }
          },
        });
      },
    });
  };

  var openEditDialog = function (item) {
    createNameDialog({
      title: options.texts.edit,
      label: options.texts.groupName,
      value: item.rawTitle,
      confirmText: options.texts.confirm,
      cancelText: options.texts.cancel,
      requiredText: options.texts.groupNameRequired,
      onConfirm: function (value, index) {
        var load = layer.load();
        $.ajax({
          type: 'post',
          dataType: 'json',
          url: options.updateUrl,
          data: { title: value, id: item.id },
          success: function (result) {
            layer.close(load);
            if (result.code == 0) {
              layer.close(index);
              layer.msg(options.texts.renameSuccess);
              reload();
            } else {
              layer.msg(options.texts.renameFailed);
            }
          },
        });
      },
    });
  };

var removeCategory = function (item) {
    if (item.children && item.children.length) {
      layer.msg(options.texts.deleteGroupWithChildren);
      return;
    }

    var dialogOptions = getMediaDialogFormOptions();
    layer.open({
      type: 1,
      title: options.texts.deleteGroup,
      closeBtn: 1,
      shadeClose: false,
      skin: dialogOptions.skin,
      resize: false,
      scrollbar: false,
      area: dialogOptions.area,
      content: createMediaConfirmHtml(
        escapeHtml(options.texts.confirmDeleteGroup),
      ),
      btn: [options.texts.confirm, options.texts.cancel],
      yes: function (index) {
        layer.close(index);
        var load = layer.load();
        $.ajax({
          type: 'post',
          dataType: 'json',
          url: options.deleteUrl,
          data: { id: item.id },
          success: function (result) {
            layer.close(load);
            if (result.code == 0) {
              var currentId = normalizeId(options.getSelectedId());
              if (currentId === item.id) {
                options.setSelectedId(0);
              }
              layer.msg(options.texts.deleteSuccess);
              reload();
              if (currentId === item.id && typeof options.onSelect === 'function') {
                options.onSelect(0);
              }
            } else {
              layer.msg(options.texts.deleteFailed);
            }
          },
        });
      },
    });
  };

  $container.off('.mediaCategoryTree');
  $container.on('click.mediaCategoryTree', '.media-category-root', function () {
    selectCategory(0, true);
  });
  $container.on('click.mediaCategoryTree', '.media-category-action', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var action = $(this).data('action');
    var id = normalizeId($(this).closest('.layui-tree-set').data('id'));
    var item = state.map[id];

    if (!item) {
      return;
    }

    if (action === 'add') {
      openAddDialog(item.id);
    } else if (action === 'edit') {
      openEditDialog(item);
    } else if (action === 'delete') {
      removeCategory(item);
    }
  });

  $(options.addButton)
    .off('.mediaCategoryTree')
    .on('click.mediaCategoryTree', function () {
      openAddDialog(options.getSelectedId());
    });

  renderShell();

  return {
    reload: reload,
    buildMoveOptionsHtml: function () {
      var html =
        "<option value='0'>" + escapeHtml(options.allLabel) + '</option>';

      state.flatData.forEach(function (item) {
        var indent = item.level > 0 ? new Array(item.level + 1).join('　　') + '└ ' : '';
        html +=
          "<option value='" +
          escapeHtml(item.id) +
          "'>" +
          escapeHtml(indent + item.title) +
          '</option>';
      });

      return html;
    },
  };
};

export { createMediaCategoryTree };
